import { render } from "./StudentCoursesSlider.vue?vue&type=template&id=cb111322&scoped=true"
import script from "./StudentCoursesSlider.vue?vue&type=script&lang=js"
export * from "./StudentCoursesSlider.vue?vue&type=script&lang=js"

import "./StudentCoursesSlider.vue?vue&type=style&index=0&id=cb111322&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb111322"]])

export default __exports__